import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Scrollspy from 'react-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import { DrawerContext } from '../../contexts/DrawerContext';
import { Link } from 'gatsby';
import DropdownMenu from './../Dropdown';
import styled from 'styled-components';

const MenuWrap = styled.div`
  .dropdown {
    span {
      color: #fff;
      font-size: 16px;
    }
  }

  .drop-list {
    li {
      width: 100%;
      padding: 12px !important;

      a {
        color: #000 !important;
      }

      &:hover {
        border-radius: 3px;
      }
    }
  }
`;

const ScrollSpyMenu = ({ className, menuItems, drawerClose, ...props }) => {
  const { dispatch } = useContext(DrawerContext);
  // empty array for scrollspy items
  const scrollItems = [];

  // convert menu path to scrollspy items
  menuItems.forEach(item => {
    scrollItems.push(item.path.slice(1));
  });

  // Add all classs to an array
  const addAllClasses = ['scrollspy__menu'];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  // Close drawer when click on menu item
  const toggleDrawer = () => {
    dispatch({
      type: 'TOGGLE'
    });
  };

  return (
    <MenuWrap>
      <Scrollspy
        items={scrollItems}
        className={addAllClasses.join(' ')}
        drawerClose={drawerClose}
        {...props}
      >
        {className === 'mobile_menu' ? (
          <>
            <li>
              <Link to="/buy-a-service">Buy a Service</Link>
            </li>
            <li>
              <Link to="/provide-a-service">Provide a Service</Link>
            </li>
          </>
        ) : (
          <li>
            <DropdownMenu
              content={'Platform'}
              dropdownItems={[
                {
                  label: 'Buy a Service',
                  link: '/buy-a-service'
                },
                {
                  label: 'Provide a Service',
                  link: '/provide-a-service'
                }
              ]}
              labelClass="dropdown"
              className="drop-list"
            />
          </li>
        )}

        {menuItems.map((menu, index) => {
          if (menu.label === 'News') {
            return (
              <>
                {' '}
                {className === 'mobile_menu' ? (
                  <>
                    <li>
                      <a href="https://news.flipserve.com/">News</a>
                    </li>
                    <li>
                      <a href="https://news.flipserve.com/videos/">Videos</a>
                    </li>
                    <li>
                      <a href="https://news.flipserve.com/blogs/">Blogs</a>
                    </li>
                    <li>
                      <a href="https://news.flipserve.com/whitepapers/">
                        Whitepapers
                      </a>
                    </li>
                    <li>
                      <a href="https://news.flipserve.com/pressrelease/">
                        Press Release
                      </a>
                    </li>
                  </>
                ) : (
                  <li>
                    <DropdownMenu
                      content={'News'}
                      link={'https://news.flipserve.com/'}
                      dropdownItems={[
                        {
                          label: 'Videos',
                          link: 'https://news.flipserve.com/videos/'
                        },
                        {
                          label: 'Blogs',
                          link: 'https://news.flipserve.com/blogs/'
                        },
                        {
                          label: 'Whitepapers',
                          link: 'https://news.flipserve.com/whitepapers/'
                        },
                        {
                          label: 'Press Release',
                          link: 'https://news.flipserve.com/pressrelease/'
                        }
                      ]}
                      labelClass="dropdown"
                      className="drop-list"
                    />
                  </li>
                )}
              </>
            );
          } else {
            return (
              <li key={`menu-item-${index}`}>
                {/* <>
              <Link to={menu.path}>{menu.label}</Link>
            </> */}
                {menu.label === 'News' ? (
                  <a href={menu.path}>{menu.label}</a>
                ) : (
                  <>
                    <Link to={menu.path}>{menu.label}</Link>
                  </>
                )}
              </li>
            );
          }
        })}
      </Scrollspy>
    </MenuWrap>
  );
};

ScrollSpyMenu.propTypes = {
  /** className of the ScrollSpyMenu. */
  className: PropTypes.string,

  /** menuItems is an array of object prop which contain your menu
   * data.
   */
  menuItems: PropTypes.array.isRequired,

  /** Class name that apply to the navigation element paired with the content element in viewport. */
  currentClassName: PropTypes.string,

  /** Class name that apply to the navigation elements that have been scrolled past [optional]. */
  scrolledPastClassName: PropTypes.string,

  /** HTML tag for Scrollspy component if you want to use other than <ul/> [optional]. */
  componentTag: PropTypes.string,

  /** Style attribute to be passed to the generated <ul/> element [optional]. */
  style: PropTypes.object,

  /** Offset value that adjusts to determine the elements are in the viewport [optional]. */
  offset: PropTypes.number,

  /** Name of the element of scrollable container that can be used with querySelector [optional]. */
  rootEl: PropTypes.string,

  /**
   * Function to be executed when the active item has been updated [optional].
   */
  onUpdate: PropTypes.func
};

ScrollSpyMenu.defaultProps = {
  componentTag: 'ul',
  currentClassName: 'is-current'
};

export default ScrollSpyMenu;
